export default __webpack_public_path__ + "static/media/design-13.1a773e00.png";